import { useTimeoutFn } from '@vueuse/core';

const UNMUTE_DELAY_MS = 100;

interface UseVideoUnmuteOptions {
	videoElementRef: Ref<HTMLVideoElement | null>;
	isMuted: () => boolean;
}

export function useVideoUnmute(options: UseVideoUnmuteOptions) {
	const { videoElementRef, isMuted } = options;

	const hasUnmuteFailed = ref(false);

	const { start: startUnmuteDelay, stop: stopUnmuteDelay } = useTimeoutFn(
		() => {
			const video = videoElementRef.value;
			if (!video || isMuted() || video.paused) return;

			video.muted = false;

			requestAnimationFrame(() => {
				const currentVideo = videoElementRef.value;
				if (video !== currentVideo) return;

				if (video.paused && !video.ended) {
					hasUnmuteFailed.value = true;
					video.muted = true;
					video.play().catch(() => {});
				}
			});
		},
		UNMUTE_DELAY_MS,
		{ immediate: false }
	);

	function reset() {
		hasUnmuteFailed.value = false;
	}

	return {
		hasUnmuteFailed,
		startUnmuteDelay,
		stopUnmuteDelay,
		reset
	};
}
